import * as React from 'react';
import { UserMenu } from '../UserMenu/UserMenu';
import { Breadcrumb } from '@dynamika-shared/ui/Breadcrumb/Breadcrumb';
import { useBreadcrumbsSlice } from '@restore/breadcrumbs/breadcrumbs.slice';
import { useNavbarContext } from './NavbarContext';

export const Navbar: React.FC = () => {
  const breadcrumbsItems = useBreadcrumbsSlice(s => s.data);
  const { rightContent } = useNavbarContext();

  return (
    <nav
      data-testid='Navbar'
      className='flex min-h-[5.6rem] w-full items-center justify-between border-b px-4'
    >
      <div data-testid='Breadcrumbs' className=''>
        <Breadcrumb items={breadcrumbsItems} />
      </div>
      <div className='flex items-center gap-4'>
        {rightContent}
        <UserMenu />
      </div>
    </nav>
  );
};

export default Navbar;
